<article>
  <header>
    <div class="tabview-list no-print">
      <div [class.active]="tabIndex() === 0" (click)="tabIndexSet(0)"><i class="mdi mdi-view-list"></i> Assets</div>
      <div [class.active]="tabIndex() === 1" (click)="tabIndexSet(1)"><i class="mdi mdi-view-list"></i> Sites</div>
      <!--<div [class.active]="tabIndex() === 2" (click)="tabIndexSet(2)"><i class="mdi mdi-view-list"></i> Old Assets View</div>-->
      <div></div>
    </div>
  </header>
  <main>
    @switch (tabIndex()) {
      @case (2) {
        <app-toolbar size="small">
          <div class="right">
            <app-button size="small" label="Previous Year" icon="mdi mdi-arrow-left" (click)="goBack()" />
            <app-button title="Year displayed" tooltipPosition="left" size="small" [label]="onYear()" [isDisabled]="true"></app-button>
            <app-button size="small" label="Next Year" icon="mdi mdi-arrow-right" iconPos="right" (click)="goForward()" />
          </div>
        </app-toolbar>

        <table class="table table-hover sticky">
          <thead>
            <tr>
              <th>Asset</th>
              <th>Site</th>
              @for (month of months; track month) {
                <th class="text-right">{{ month }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (asset of assets(); track asset.id) {
              <tr [routerLink]="['/energy/site', asset.site_id]">
                <td>{{ asset.title }}</td>
                <td>{{ asset.site_title }}</td>

                @for (month of months; track month; let monthIndex = $index) {
                  @if (!asset.months) {
                    <td class="text-right" style="font-size: 8px" title="No Data">x</td>
                  } @else {
                    @if (asset.months[monthIndex] === null) {
                      <td class="text-right" style="color: #a0a0a0">-</td>
                    } @else {
                      <td class="text-right">
                        {{ asset.months[monthIndex] | number: '1.0' }}
                      </td>
                    }
                  }
                }
              </tr>
            }
            <tr class="footer">
              <td colspan="2" class="text-left">Total</td>
              @for (total of grandTotals; track $index) {
                <td class="text-right">{{ total | number: '1.0' }}</td>
              }
            </tr>
          </tbody>
        </table>
        @if (!assets()) {
          <i class="mdi mdi-loading mdi-spin-x2"></i>
        }
      }
      @case (1) {
        @if (dataTableSites) {
          <app-data-table [dataTable]="dataTableSites" (onRowClick)="dataTableSiteClick($event)" [footerTotals]="grandTotals" dataTableKey="energy:list:sites" [dimZeros]="true" />
        }
      }
      @default {
        <app-toolbar size="small">
          <div class="right">
            <app-button size="small" label="Gas" icon="mdi mdi-gas-burner" (click)="toggle('gas')" [selected]="gasToggle()" />
            <app-button size="small" label="Electric" icon="mdi mdi-lightning-bolt" (click)="toggle('electric')" [selected]="electricToggle()" /> &nbsp;
            <app-button size="small" label="Previous Year" icon="mdi mdi-arrow-left" (click)="goBack()" />
            <app-button title="Year displayed" tooltipPosition="left" size="small" [label]="onYear()" [isDisabled]="true"></app-button>
            <app-button size="small" label="Next Year" icon="mdi mdi-arrow-right" iconPos="right" (click)="goForward()" />
          </div>
        </app-toolbar>
        @if (dataTableAssets()) {
          <app-data-table [dataTable]="dataTableAssets()" (onRowClick)="dataTableAssetClick($event)" [footerTotals]="grandTotals" dataTableKey="energy:list:assets" [dimZeros]="true" />
        } @else {
          <i class="mdi mdi-loading mdi-spin-x2"></i>
        }
      }
    }
  </main>
  @if (asset()) {
    <app-dialog (onClose)="asset.set(null)" [dimensions]="{ height: 620, width: 900 }" [header]="asset().title + ', meter ' + meterRef()">
      <div>
        <app-energy-asset-graph [asset]="asset()" [year]="onYear()" [height]="400" />
      </div>
    </app-dialog>
  }
</article>
